import { Component, OnInit, Input, Renderer2, ElementRef  } from '@angular/core';
import { DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { Router } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';


@Component({
  selector: 'app-template-b',
  standalone: true,
  imports: [ MatButtonModule, MatProgressSpinnerModule, MatCardModule, MatIconModule],
  templateUrl: './template-b.component.html',
  styleUrl: './template-b.component.scss'
})
export class TemplateBComponent {

  public _templateData :any = null;
  moreButton = false;

  @Input()
  set templateData(value : any) {
    this._templateData = value
    this.redraw()
  }

  @Input() canEdit :boolean = false
  isEditable = false

  safeHtmlBody: any;

  currentSelections = Array()
  currentFirstSection = 0
  currentLastSection = 1

  constructor(private sanitizer: DomSanitizer, private router: Router, private renderer: Renderer2, private el: ElementRef){

  }

  redraw() {

    this.safeHtmlBody = this.sanitizer.bypassSecurityTrustHtml(this._templateData.bodyText)
    if (this._templateData.backgroundImage && this._templateData.backgroundImage.length > 1) {
      this.renderer.setStyle(this.el.nativeElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('div'), 'background-image', `url(${this._templateData.backgroundImage})`);
    } else {
      this.renderer.setStyle(this.el.nativeElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('div'), 'background-image', `url(${''})`);
    }

    this.currentFirstSection = 0
    if (this._templateData.context.length > 1) {
      this.currentFirstSection = 0
      this.currentLastSection = this.currentFirstSection + 1
    } else {
      this.currentLastSection = 0
    }
    this.populateSelections()

  }

  populateSelections() {
    this.currentSelections = new Array()

    this.currentSelections.push(this.currentFirstSection)
    this.currentSelections.push(this.currentLastSection)

  }

  nextSection() {

    if (this.currentLastSection == this._templateData.context.length - 1) {
      this.currentFirstSection = this._templateData.context.length - 1
      this.currentLastSection = 0
    } else {
      this.currentFirstSection ++
      this.currentLastSection ++
      if (this.currentFirstSection > this._templateData.context.length - 1) {
        this.currentFirstSection = 0
      }
    }
    this.populateSelections()
  }

  previousSection() {

    if (this.currentFirstSection == 0) {
      this.currentFirstSection = this._templateData.context.length - 1
      this.currentLastSection = 0
    } else {
      this.currentFirstSection --
      this.currentLastSection --
      if (this.currentLastSection < 0) {
        this.currentLastSection = this._templateData.context.length - 1
      }
    }
    this.populateSelections()
  }

  onButtonClick(url :string){
    this.router.navigate([url])
  }

  onMoreButtonClick( insert : any){
    if (insert.more){
      delete insert.more
    } else {
      insert['more'] = true
    }

  }

}
